import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function SimpleSlider() {
  const settings = {
    dots: true,
    arrow: false,
    infinite: true,
    speed: 20,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: false,
    margin: 30,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1
        },
      },
      {
        breakpoint: 420,
        settings: {
          slidesToShow: 1
        },
      },
    ],
  };

  const TestimonilContent = [
    {
      imageName: "team-1",
      desc: `Maya has been working with us for several months; she is creative and reliant and works perfectly with every team in our company. We would gladly recommend her experience and UX/UI professionalism `,
      reviewerName: "Seo Top",
      designation: "CTO at Seo Top Israel",
      delayAnimation: "",
    },
    {
      imageName: "team-2",
      desc: `Experienced UX designer and researcher and UI Designer, made everything look more straightforward and doable`,
      reviewerName: "QanonCoin CEO",
      designation: "CTO at QanonCoin",
      delayAnimation: "200",
    },
  ];

  return (
    <div className="testimonial-wrapper">
      <Slider {...settings}>
        {TestimonilContent.map((val, i) => (
          <div
            key={i}
            data-aos="fade-up"
            data-aos-duration="1200"
            data-aos-delay={val.delayAnimation}
          >
            <div className="testimonial-01 media">
              <div className="avatar">
                <img
                  src={`img/testimonial/${val.imageName}.jpg`}
                  alt="review comments"
                ></img>
              </div>
              <div className="media-body">
                <p>{val.desc}</p>
                <h6>{val.reviewerName}</h6>
                <span>{val.designation}</span>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
}
